<!-- Built with Common Launchpad 2.0.3 -->

<template>
    <form @submit.prevent="onSubmit" class="search-form js-search-form">
        <div class="input-group">
            <label for="header-search" class="sr-only">Search</label>
            <!-- <typeahead :options="options" @update-search="searchNewUrl" @update-input="searchNewUrl" @run-search="triggerSearch" @update-typeahead="getTypeaheadItems"></typeahead> -->
            <headertypeahead :options="options" :current-search-term="searchQuery" @update-search="searchNew" @update-typeahead="getTypeaheadItems"></headertypeahead>
        </div>
    </form>
</template>

<script>
import {debounce} from 'lodash';
import HeaderTypeahead from '../../components/ui/nav-header-typeahead';

export default {
    name: 'HeaderTypeahead',
    data: function () {
			return {
                searchQuery: '',
                searchedQuery: '',
                isDropdownOpen: true,
                typeAheadItems: [],
                options: []
			}
		},
    components: {
        headertypeahead: HeaderTypeahead
    },

    methods: {
        onSubmit() {
            // leave this method to prevent default form
            //console.log('form submitted');
        },
        // closeTypeahead() {
        //     console.log('closing typeahead');
        //     this.$refs.Typeahead.onBlur();
        // },
        copyWithHighlights(copy) {
            // if(copy == ''){
            //     copy = 'no summary available : ...';
            // }
            const term = this.searchedQuery; // search query we want to highlight in results
            const newCopy = copy.replace(new RegExp(term, "gi"), (match) => `<mark>${match}</mark>`);

            return newCopy;
        },
        setQuery(item) {
            console.log('set query');
            this.searchQuery = item.Title;
            this.isDropdownOpen = false;
            this.searchNew();
        },
        readyNewSearch() {
            if(this.searchQuery.length > 2){
                this.typeAheadSearch();
            }
        },
        searchNew(query) {
            this.searchedQuery = query;
            let str = `/search?query=${this.searchedQuery}&PageIndex=0&PageSize=10`;
            window.location.href = str;
        },
        getTypeaheadItems(query) {
            console.log('get type ahead items. query: ', query);

            if(query === ''){
                this.options = [];
                return;
            }

            this.searchQuery = query;
            this.typeAheadSearch();
        },
        typeAheadSearch: debounce(function(){
            fetch(`/api/typeahead?Query=${this.searchQuery}&PageIndex=0&PageSize=7`)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    this.options = data;
                })
                .catch(error => {
                    console.error('There has been a problem with your fetch operation:', error);
                    this.options = [];
                });
        }, 500),
    }
}
</script>